<template>
<v-main>
  <head>
    <title>
      My Shops - Foraje
    </title>
    <meta name="description" content="Your Shops/Farmstands">
  </head>
  <v-container
    fluid
  >
    <v-row   v-if="areshopsloading">
      <v-col cols="12" class="text-center">
        <v-progress-circular
          :size="100"
          :width="7"
          color="primary"
          indeterminate
        />
      </v-col>
    </v-row>
    <v-row
      style="justify-content: center"
      v-else-if="shops && shops.length"
    >
      <v-col cols="12"><v-card flat><v-card-title style="justify-content: center"><h1 style="justify-content: center">My Shops</h1></v-card-title></v-card></v-col>
      <v-col cols="12" :md="numberOfColumns" v-for="(shop, index) in shops" :key="index">
  <v-card class="fill-height">
<!--    <v-btn fab absolute top right><v-icon color="primary">mdi-pencil</v-icon></v-btn>-->
    <v-card-title>
      <router-link :to="'/shops/' + shop.slug">
      {{shop.name}}
      </router-link>
      <v-badge
        color="success"
        right
        v-if="shop.approved"
      >
        <template v-slot:badge>
      <v-tooltip top v-if="shop.approved">
        <template v-slot:activator="{ on }">
      <v-icon v-on="on">
        mdi-check
      </v-icon>
        </template>
        <span>This shop has been approved!</span>
      </v-tooltip>
        </template>
      </v-badge>
        <v-badge
          right
          v-else
          color="grey"
        >
        <template v-slot:badge>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">
            mdi-tilde
          </v-icon>
        </template>
        <span>This shop hasn't been approved yet.</span>
      </v-tooltip>
        </template>
        </v-badge>
      <v-spacer/>
          <router-link :to="'/forms/shop/edit/' + shop.slug">
            <v-tooltip top>
              <span>Edit shop Information</span>
              <template v-slot:activator="{ on }">
          <v-btn icon color="primary" v-on="on">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
              </template>
            </v-tooltip>
          </router-link>
      <router-link :to="'/forms/shop/products/' + shop.slug" class="pl-1">
        <v-tooltip top>
          <span>Edit products at this shop</span>
        <template v-slot:activator="{ on }">
      <v-btn icon color="primary" v-on="on">
        <v-icon light>mdi-package-variant-closed</v-icon>
      </v-btn>
        </template>
        </v-tooltip>
      </router-link>
    </v-card-title>
    <v-card-text>
        <span>{{shop.description}}</span>
      <p>{{shop.address}}</p>
    </v-card-text>
    <v-card-text>
      <div v-for="(hour, index) in shop.cleaned_hours" :key="index">
        <b v-if="hour.weekday === todayIs">{{hour.weekday_display}} : <span v-for="(opentime, index) in hour.open_time" :key="index">
                  <span v-if="opentime && opentime.length">{{opentime}} - {{hour.close_time[index]}} <span v-if="index + 1 < hour.open_time.length">,</span></span>
                  <span v-else>Closed</span>
                </span>
        </b>
        <span v-else>{{hour.weekday_display}} : <span v-for="(opentime, index) in hour.open_time" :key="index">
                    <span v-if="opentime && opentime.length"> {{opentime}} - {{hour.close_time[index]}}<span v-if="index + 1 < hour.open_time.length">, </span> </span>
                    <span v-else>Closed</span>
                  </span>
                  </span>
      </div>
    </v-card-text>
  </v-card>
      </v-col>
    </v-row>
    <v-row
      style="justify-content: center"
      v-else
    >
      <v-col cols="12">
        <v-card>
          <v-card-title style="justify-content: center">It doesn't look like you have a shop listed on Foraje yet!</v-card-title>
          <v-card-text>If you would like to list your shop on Foraje, go ahead and create a shop by clicking the green button on the bottom right, <router-link  :to="'/forms/shop/create/'">or by clicking here!</router-link></v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-btn
      dark
      fab
      bottom
      right
      fixed
      color="green"
      @click="CreateNewShop"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MyShops',
  data: () => ({
    areshopsloading: false,
    shops: [],
  }),
  methods: {
    GetThisUsersShops() {
      this.areshopsloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('basics/table/shops/by/owner/',

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.shops = response.data;
        })
        .then(() => {
          this.shops.forEach((shop) => {
            // eslint-disable-next-line no-param-reassign
            // eslint-disable-next-line no-param-reassign
            shop.cleaned_hours = this.cleanHours(shop.hours);
          });
        })
        .then(() => {
          this.areshopsloading = false;
        });
    },
    CreateNewShop() {
      this.$router.push('/forms/shop/create/');
    },
    cleanHours(array) {
      const output = array.reduce((o, cur) => {
        let newO = o;
        // Get the index of the key-value pair.
        const occurs = o.reduce((n, item, i) => ((item.weekday === cur.weekday) ? i : n), -1);

        // If the name is found,
        if (occurs >= 0) {
          // append the current value to its list of values.
          newO[occurs].open_time = newO[occurs].open_time.concat(cur.open_time);
          newO[occurs].close_time = newO[occurs].close_time.concat(cur.close_time);

          // Otherwise,
        } else {
          // add the current item to o (but make sure the value is an array).
          const obj = {
            weekday: cur.weekday,
            weekday_display: cur.weekday_display,
            open_time: [cur.open_time],
            close_time: [cur.close_time],
          };
          newO = newO.concat([obj]);
        }

        return newO;
      }, []);

      return output;
    },
  },
  // Fetches Shops when the component is created.
  created() {
    this.GetThisUsersShops();
  },
  computed: {
    numberOfColumns() {
      if (this.shops) {
        if (this.shops.length === 1) {
          return 10;
        } if (this.shops.length === 2) {
          return 6;
        }
        return 4;
      }
      return 12;
    },
    todayIs() {
      const date = new Date();
      return date.toLocaleDateString((window.navigator.language), { weekday: 'long' });
    },
  },
};
</script>

<style scoped>

</style>
